import React from "react"
import Map from "../shared/about/Map"

const parameters = 'pb=!1m18!1m12!1m3!1d3222.6738031691057!2d139.3756479!3d36.125803999999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601f297d230e83c7%3A0xf02f959b073c3d85!2zbm9vbmXvvIjjg47jg7zjg43vvIk!5e0!3m2!1sja!2sjp!4v1747294265856!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>'

const AboutMap = () => {
  return <Map parameters={ parameters } />
}

export default AboutMap
